import moment from "moment";
import { useState } from "react";
import { onColumnResizeHof } from "../../pages/Orders/helpers";
import { TABLE_COLUMNS } from "../../pages/OrderCashOut/constants";

const useCashOutOverview = (overviewReport) => {
  const [columnWidths, setColumnWidths] = useState([]);
  const onColumnResize = onColumnResizeHof({
    columnWidths,
    setColumnWidths,
    TABLE_COLUMNS
  });
  let bank = overviewReport ? overviewReport.accounts[0].bank : undefined;

  const payments = overviewReport
    ? overviewReport.payments.map((payment) => ({
        id: payment.order.id,
        name: payment.order.product.name,
        amount: `$${payment.amountDue}`,
        status: payment.paid ? "Paid" : "Unpaid",
        paymentVendor: payment.paymentVendor,
        createdAt: moment(payment.createdAt).format("MMM D, YYYY hh:mm A")
      }))
    : [];
  return {
    payments,
    amountDue: overviewReport ? overviewReport.earnings.owed : "",
    bank,
    onColumnResize,
    columnWidths
  };
};

export default useCashOutOverview;
